define('app/views/templates/helpers/momentDateFormat',['Handlebars','moment'], function ( Handlebars,moment ){
    function momentDateFormat(date, format) {
        return moment(date,'YYYY-MM-DDHHmmss').format(format);
    }
    Handlebars.registerHelper( 'momentDateFormat', momentDateFormat );
    return momentDateFormat;
});
        
